import { captureError } from 'common/utils/error.util';
import { AccountService } from 'common/services/account.service';
import { observable, action, computed, makeObservable } from 'mobx';
import { handleTimeRangeOption } from '../pages/AccountOperation/util';

class OperationDetailsStore {
  @observable operation = null;

  @observable isLoading = false;

  @observable related = [];

  @observable
  selectedOptions = {
    kind: { value: null, label: 'All' },
    date: { value: '1M', label: '1 month' },
  };

  @observable
  filters = {
    ...handleTimeRangeOption('1M'),
    kind: null,
  };

  @observable
  tableOffset = 0;

  constructor() {
    makeObservable(this);
  }

  @computed
  get getSelectedOptions() {
    return this.selectedOptions;
  }

  @computed
  get getFilters() {
    return this.filters;
  }

  @computed
  get getTableOffset() {
    return this.tableOffset;
  }

  @action.bound
  setSelectedOptions = (value) => {
    this.selectedOptions = {
      ...this.selectedOptions,
      ...value,
    };
  };

  @action.bound
  setFilters = (value) => {
    this.filters = {
      ...this.filters,
      ...value,
    };
  };

  @action.bound
  setTableOffset = (value) => {
    this.tableOffset = value;
  };

  @action.bound
  setOperation = (operation) => {
    this.operation = operation;
  };

  @action.bound
  fetchRelated = (accountID) => {
    this.isLoading = true;
    AccountService.getPosition(accountID, this.operation.operation.position_id)
      .then((posData) => {
        this.related = posData.data;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        captureError(error);
      });
  };
}

export default new OperationDetailsStore();
